export default {
  "b2b.zadosti-row-detail.telefon.label": "Telephone",
  "b2b.zadosti-row-detail.email.label": "E-Mail",
  "b2b.zadosti-row-detail.projekt.label": "Project",
  "b2b.zadosti-row-detail.produkt.label": "Product",
  "b2b.zadosti-row-detail.doplnkove-sluzby.label": "Add. services",
  "b2b.zadosti-row-detail.poznamky.label": "Notes",
  "b2b.zadosti-row-detail.poznamky-zakaznik.label": "Customer",
  "b2b.zadosti-row-detail.poznamky-strojvedouci.label": "Driver",
  "b2b.zadosti-row-detail.poznamky-spravce.label": "Administrator"
};
